import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.scss';
import { fetchFooterContent } from '../../utils/contentful/Constants.ts';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const [,setLoading] = useState(true);
  const [layoutFooterlink, setlayoutFooterlink] = useState('');
  const [layoutFooterlink0, setlayoutFooterlink0] = useState('');
  const [layoutFooterlink1, setlayoutFooterlink1] = useState('');
  const [layoutFooterlink2, setlayoutFooterlink2] = useState('');
  const [layoutFooterlink3, setlayoutFooterlink3] = useState('');
  const [layoutFooterlink4, setlayoutFooterlink4] = useState('');
  const [layoutFooterlink5, setlayoutFooterlink5] = useState('');
  const [layoutFooterlink6, setlayoutFooterlink6] = useState('');
  const [layoutFooterlink7, setlayoutFooterlink7] = useState('');
  const [layoutFooterlink8, setlayoutFooterlink8] = useState('');
  const [disclaimerHeading, setDisclaimerHeading] = useState('');
  const [layoutFooter, setlayoutFooter] = useState('');
  const [layoutFooter1, setlayoutFooter1] = useState('');
  const [layoutFooter2, setlayoutFooter2] = useState('');
  const [layoutFooterContent, setlayoutFooterContent] = useState('');
  const [layoutFooterContent1, setlayoutFooterContent1] = useState('');
  const [layoutFooterContent2, setlayoutFooterContent2] = useState('');
  const [layoutFooterContent3, setlayoutFooterContent3] = useState('');
  const [layoutFooterContent4, setlayoutFooterContent4] = useState('');

  useEffect(() => {
    fetchFooterContent()
      .then((data: any) => {
        console.log('📥 Fetched Footer Content:', data);

        const foundlayoutFooterlink = data.includes?.Entry?.find(
          (entry: any) => entry.fields?.id === 'hs-member-layout-footer-link1'
        ).fields.text;
          setlayoutFooterlink(foundlayoutFooterlink);

        const foundlayoutFooterlink0 = data.includes?.Entry?.find(
          (entry: any) => entry.fields?.id === 'hs-member-layout-footer-link2'
        ).fields.text;
          setlayoutFooterlink0(foundlayoutFooterlink0);

        const foundlayoutFooterlink1 = data.includes?.Entry?.find(
          (entry: any) => entry.fields?.id === 'hs-member-layout-footer-link3'
        ).fields.text;
          setlayoutFooterlink1(foundlayoutFooterlink1);

        const foundlayoutFooterlink2 = data.includes?.Entry?.find(
          (entry: any) => entry.fields?.id === 'hs-member-layout-footer-link4'
        ).fields.text;
          setlayoutFooterlink2(foundlayoutFooterlink2);

        const foundlayoutFooterlink5 = data.includes?.Entry?.find(
          (entry: any) => entry.fields?.id === 'hs-member-layout-footer-link7'
        ).fields.text;
          setlayoutFooterlink5(foundlayoutFooterlink5);

        const foundHeading = data.includes?.Entry?.find(
          (entry: any) => entry.fields?.id === 'hs-member-layout-footer-disclaimer-heading'
        ).fields.title;
          setDisclaimerHeading(foundHeading);

        const foundlayoutFooter = data.includes?.Entry?.find(
          (entry: any) => entry.fields?.id === 'hs-member-layout-footer-disclaimer-content-block-item1'
        ).fields?.content?.content[0]?.content[0]?.value;
          setlayoutFooter(foundlayoutFooter);

        const foundlayoutFooter1 = data.includes?.Entry?.find(
          (entry: any) => entry.fields?.id === 'hs-member-layout-footer-disclaimer-content-block-item1'
        ).fields?.content?.content[0]?.content[0]?.value;
          setlayoutFooter1(foundlayoutFooter1);

        const foundlayoutFooter2 = data.includes?.Entry?.find(
          (entry: any) => entry.fields?.id === 'hs-member-layout-footer-disclaimer-content-block-item1'
        ).fields?.content?.content[0]?.content[2]?.value;
          setlayoutFooter2(foundlayoutFooter2);

        const foundlayoutFooterContent = data.includes?.Entry?.find(
          (entry: any) => entry.fields?.id === 'hs-member-layout-footer-disclaimer-content-block-item2'
        ).fields?.content?.content[0]?.content[0]?.value;
          setlayoutFooterContent(foundlayoutFooterContent);

        const foundlayoutFooterContent1 = data.includes?.Entry?.find(
          (entry: any) => entry.fields?.id === 'hs-member-layout-footer-disclaimer-content-block-item3'
        ).fields?.content?.content[0]?.content[0]?.value;
          setlayoutFooterContent1(foundlayoutFooterContent1);

        const foundlayoutFooterContent2 = data.includes?.Entry?.find(
          (entry: any) => entry.fields?.id === 'hs-member-layout-footer-disclaimer-content-block-item3'
        ).fields?.content?.content[0]?.content[3]?.content[0].value;
          setlayoutFooterContent2(foundlayoutFooterContent2);

        const foundlayoutFooterContent3 = data.includes?.Entry?.find(
          (entry: any) => entry.fields?.id === 'hs-member-layout-footer-disclaimer-content-block-item4'
        ).fields?.content?.content[0]?.content[0]?.value;
          setlayoutFooterContent3(foundlayoutFooterContent3);

        const foundlayoutFooterContent4 = data.includes?.Entry?.find(
          (entry: any) => entry.fields?.id === 'hs-member-layout-footer-disclaimer-content-block-item3'
        ).fields?.content?.content[0]?.content[1]?.value;
          setlayoutFooterContent4(foundlayoutFooterContent4);
      })
      .catch((err: unknown) => {
        console.error('❌ Footer Contentful Error:', err);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <footer className="footer">
      <div className="footer-container">
        <p className="footer-note"><b>Contact Us</b></p>
        <p className="footer-note">Help with registration or login: <b>1 (800) 853-2713 (TTY/TDD dial 711)</b>
        </p>
        <p className="footer-note">©2025 HealthSpring.All rights reserved.FPO</p>
        <ul className="footer-links">
          <li>
            <a
              href="http://www.healthspring.com/legal-privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              {layoutFooterlink}
            <img src="/static/images/External_Icon_footer.svg" alt="" className="external-link-icon"/>
            </a>
          </li>
          <li>
            <a
              href="https://www.healthspring.com/static/docs/medicare/resources/notice-nondiscrimination.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              {layoutFooterlink0}
              <img src="/static/images/External_Icon_footer.svg" alt="" className="external-link-icon"/>
            </a>
          </li>
          <li>
            <a
              href="https://www.healthspring.com/static/docs/medicare/resources/notice-of-availability.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              {layoutFooterlink1}
              <img src="/static/images/External_Icon_footer.svg" alt="" className="external-link-icon"/>
            </a>
          </li>
          <li>
            <a
              href="https://www.healthspring.com/static/docs/medicare/resources/notice-privacy.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
            {layoutFooterlink2}
              <img src="/static/images/External_Icon_footer.svg" alt="" className="external-link-icon"/>
            </a>
          </li>
          <li>
            <a
              href="https://www.healthspring.com/medicare/member-resources/grievances"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              {layoutFooterlink5}
              <img src="/static/images/External_Icon_footer.svg" alt="" className="external-link-icon"/>
            </a>
          </li>

        </ul>
        <div className="divider"></div>
        <div className="disclaimer">
          <p>{disclaimerHeading}</p>
          <p>
            {layoutFooter1}
          </p>

            {layoutFooterContent}
           <br/>

           <p className='footerText'>
            <img className="pdf" src="/static/images/pdf_icon.png"></img> <div>{layoutFooterContent1} <a className="adobe-link" href='https://adobe.com'> adobe.com.</a> </div>
            </p>

          <p className='footerText'><img className="leaveIcon" src="/static/images/External_Icon_footer.svg"></img> {layoutFooterContent3}</p>



        </div>
      </div>
    </footer>
  );
};
export default Footer;
